import { render, staticRenderFns } from "./EventsDisplay.vue?vue&type=template&id=499bd6a6&scoped=true"
import script from "./EventsDisplay.vue?vue&type=script&lang=js"
export * from "./EventsDisplay.vue?vue&type=script&lang=js"
import style0 from "./EventsDisplay.vue?vue&type=style&index=0&id=499bd6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499bd6a6",
  null
  
)

export default component.exports